import Type from "./Type";
import ValidateException from "sap/ui/model/ValidateException";
import ParseException from "sap/ui/model/ParseException";
import FormatException from "sap/ui/model/FormatException";

export default class MCNumber extends Type {
    private formatOptions: { decimals?: number; showGrouping?: boolean; measure?: string };
    constructor(formatOptions?: { decimals?: number; showGrouping?: boolean; measure?: string }) {
        super();
        this.formatOptions = formatOptions || {};
        this.formatOptions.decimals = this.formatOptions.decimals || 0; // Default to 2 decimals
        this.formatOptions.showGrouping = this.formatOptions.showGrouping !== undefined ? this.formatOptions.showGrouping : true; // Default to true
        this.formatOptions.measure = this.formatOptions.measure || ""; // Default to empty string if not provided
    }

    public formatValue(value: number | string): string {
        if (value === null || value === undefined) {
            return "";
        }
        if (typeof value === "string") {
            value = parseFloat(value);
            if (isNaN(value)) {
                throw new FormatException(`Invalid number value: ${value}`) as Error;
            }
        }
        try {
            const formattedValue = value.toLocaleString(this.locale, {
                minimumFractionDigits: this.formatOptions.decimals,
                maximumFractionDigits: this.formatOptions.decimals,
                useGrouping: this.formatOptions.showGrouping,
                style: "decimal",
            });
            return this.formatOptions.measure ? `${formattedValue} ${this.formatOptions.measure}` : formattedValue;
        } catch {
            throw new FormatException(`Invalid number value: ${value}`) as Error;
        }
    }

    public parseValue(value: string): number | null {
        if (!value) {
            return null;
        }
        // Remove grouping and decimal separators based on locale
        const groupingSeperator = this.locale === "en" ? "," : ".";
        const decimalSeperator = this.locale === "en" ? "." : ",";
        const parsedValue = parseFloat(value.replace(groupingSeperator, "").replace(decimalSeperator, "."));
        if (isNaN(parsedValue)) {
            throw new ParseException(`Invalid number format: ${value}`) as Error;
        }
        return parsedValue;   
    }
    
    public validateValue(value: string): void {
        if (!value) {
            return;
        }
        const parsedValue = this.parseValue(value);
        if (parsedValue === null) {
            throw new ValidateException(`Invalid number format: ${value}`) as Error;
        }
    }
}